<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          limit: 100000
        }

        this.list = [
          {
            text: 'Semua Unit',
            value: 0
          }
        ]

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/announcement',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Judul',
              width: '400px',
              value: 'title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '400px',
              value: 'desc',
              freeze: false,
              hide: false
            },
            {
              text: 'Template',
              width: '200px',
              value: 'is_template',
              freeze: false,
              hide: false,
              format: 'y_n'
            },
            {
              text: 'Tanggal Dibuat',
              width: '200px',
              value: 'input_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'unit_id',
              label: 'Unit',
              type: 'select',
              placeholder: 'Contoh. Kantor Pusat SDM',
              value: '',
              option: this.list,
              width: '70%',
              required: false
            }
          ],

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'title',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Besok Libur',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'unit_id',
              label: 'Unit',
              type: 'select',
              placeholder: 'Contoh. Kantor Pusat SDM',
              value: '',
              option: this.list,
              width: '60%',
              required: true,
              rules: 'required'
            },
            {
              field: 'desc',
              label: 'Deskripsi',
              type: 'textarea',
              placeholder: 'Contoh. Besok libur nasional',
              value: '',
              width: '100%',
              rows: 3,
              required: true,
              rules: 'required'
            },
            {
              field: 'template_bool',
              label: 'template_bool',
              type: 'text',
              placeholder: 'Contoh. 1',
              value: 0,
              width: '0%',
              required: false,
              hide: true
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/announcement/add',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>